import {useEffect, useRef, useState} from 'react'
import {Modal, Spinner} from 'react-bootstrap'
import {createPortal} from 'react-dom'
import axios from 'axios'
import {StepperComponent} from '../../../_metronic/assets/ts/components'
import {KTSVG} from '../../../_metronic/helpers'
import { SERVER_URL } from '../../ServerConfig'
// import { Props } from '../../../_metronic/partials'
// import { defaultCreateAppData, ICreateAppData } from '../../../_metronic/partials/modals/create-app-stepper/IAppModels'

type Props = {
  show: boolean
  handleClose: () => void
  fileName: any
}

const modalsRoot = document.getElementById('root-modals') || document.body

const CertificateModel = ({show, handleClose, fileName}: Props) => {
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [loadError, setLoadError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [fileExists, setFileExists] = useState<boolean | null>(null)

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  useEffect(() => {
    const file = String(fileName || '').trim()
    setLoadError('')
    setFileExists(file ? null : false)

    if (!show || !file) {
      setIsLoading(false)
      return
    }

    const downloadUrl = `${SERVER_URL}/downloads/download?folder_name=buyerSeller&image=${encodeURIComponent(file)}`
    setIsLoading(true)

    axios
      .get(downloadUrl, { responseType: 'blob' })
      .then(() => {
        setFileExists(true)
      })
      .catch(() => {
        setFileExists(false)
        setLoadError('The GST certificate could not be retrieved. Please upload it or contact the administrator for assistance.')
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [show, fileName])

  const pdfUrl = `${SERVER_URL}/downloads/download?folder_name=buyerSeller&image=${encodeURIComponent(String(fileName || '').trim())}`

  const handleIframeError = () => {
    setIsLoading(false)
    setLoadError('The GST certificate could not be retrieved. Please upload it or contact the administrator for assistance.')
  }

  const handleIframeLoad = () => {
    setIsLoading(false)
  }

  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      dialogClassName='modal-dialog modal-dialog-centered mw-900px'
      show={show}
      onHide={handleClose}
      onEntered={loadStepper}
      backdrop={true}
    >
      <div className='modal-header border-bottom border-gray-300 border-bottom-dashed'>
        <h2> GST Certificate </h2>
        {/* begin::Close */}
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
        {/* end::Close */}
      </div>
      <div className='modal-body p-10'>
        {isLoading ? (
          <div className='d-flex align-items-center justify-content-center py-20'>
            <Spinner animation='border' size='sm' className='me-3' />
            <span>Loading GST certificate...</span>
          </div>
        ) : !fileExists ? (
          <div className='py-20 text-center'>
            <p className='fs-5 mb-3'>
              {String(fileName || '').trim()
                ? loadError || 'The GST certificate could not be retrieved. Please upload it or contact the administrator for assistance.'
                : 'No GST certificate has been uploaded yet.'}
            </p>
            {!String(fileName || '').trim() && (
              <p className='text-muted fs-7'>Please upload the document or contact the administrator for assistance.</p>
            )}
          </div>
        ) : (
          <iframe
            src={pdfUrl}
            frameBorder='0'
            scrolling='auto'
            height='600px'
            width='100%'
            title='GST Certificate'
            onError={handleIframeError}
            onLoad={handleIframeLoad}
          />
        )}
      </div>
    </Modal>,
    modalsRoot
  )
}

export {CertificateModel}
